import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TenantSolutionsComponent} from './tenant-solutions.component';
import { SolutionVersionsComponent } from './solution-versions/solution-versions.component';
import { SolutionVersionDetailsComponent } from './solution-version-details/solution-version-details.component';
import { ExternalPackageComponent } from './external-package/external-package.component';
import { ExternalTenantGuard } from 'src/app/services/util/external-tenant.guard';

const routes: Routes = [
  {
    path: '',
    component: TenantSolutionsComponent,
    title: 'Solutions',
    canActivate: [ExternalTenantGuard],
  },
  {
    path: ':solutionId/versions',
    component: SolutionVersionsComponent,
    canActivate: [ExternalTenantGuard],
  },
  {
    path: ':solutionId/external-package',
    component: ExternalPackageComponent,
    canActivate: [ExternalTenantGuard],
  },
  {
    path: ':solutionId/versions/:versionId',
    component: SolutionVersionDetailsComponent,
    canActivate: [ExternalTenantGuard],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantSolutionsRoutingModule {
}
